var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"take-detail-list"},[_c('div',{staticClass:"deatil-title"}),_c('studioSettleDetail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }